import React, { Fragment, useState } from "react";
import Modal from "../../common/Modals/Modal/Modal";
import Icon from "../../common/Icon/Icon";
import styles from "./ImageModal.module.css";
import ButtonNoStyles from "../../common/Buttons/ButtonNoStyles/ButtonNoStyles";

interface Props {
    src: string;
    label?: string;
    onCancel?: () => void;
    children: GenericModalChildren;
}

/**
 * A confirmation modal that will be used to confirm the user wants to reset the quiz.
 * @param {object} props
 * @returns {React.ReactNode}
 */
const ImageModal = ({ src, label, onCancel, children }: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    const onClose = () => {
        if (onCancel) onCancel();
        setIsOpen(false);
    };

    const onCloseClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onClose();
    };

    const onImageButtonClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsOpen(true);
    };

    const modal = (
        <Modal show={isOpen} onClose={onClose}>
            <div className={`relative ${styles.imageModal}`}>
                <img src={src} alt={label} className="max-w-[90vw] max-h-[90vh] rounded-t" />
                <div className="absolute top-0.5 right-0.5 z-10">
                    <ButtonNoStyles onClick={onCloseClick} variant="none" className="outline-none p-1">
                        <Icon icon="cross" className="text-white" />
                    </ButtonNoStyles>
                </div>
            </div>
        </Modal>
    );

    const child = React.Children.only(children);
    return (
        <Fragment>
            {React.cloneElement(
                child,
                {
                    onClick: onImageButtonClick,
                },
                child?.props?.children
            )}
            {modal}
        </Fragment>
    );
};

export default ImageModal;
